module.exports = __webpack_public_path__ + "img/layers-seven.85bab333.svg";